import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-dropdown q-position-relative"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "sorting-dropdown__label" }

import {useSortingStore} from "@/store/SerpPage/SortingStore";
import {computed, onMounted, ref, toRefs} from "vue";
import DropdownButton from '@/components/SerpPage/FiltersContainer/FiltersList/DropdownButton.vue'
import {SortInterface} from "@/core/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'SortingButtonDropDown',
  props: ['filterDataValues', 'field'],
  setup(__props) {

const sortingStore = useSortingStore();
const {selectedSort} = toRefs(sortingStore)
const isOpen = ref(false);

onMounted(() => {
  sortingStore.fetchSortingOptions()
  selectedSort.value = sortingStore.getSelectedSortFromUrl()
})



function updateSorting(sort: SortInterface) {
  sortingStore.updateSortingOnClick(sort)
  isOpen.value = false
}

function closeDropdown() {
  isOpen.value = false
}

const computedClass = computed(() => {
      const classList = [
        'serp__filter-item--group',
        'q-list-group',
        'q-list-group-flush',
        'q-list-group-collapse',
      ]
      if (isOpen.value) {
        classList.push('q-d-block')
      }
      return classList
    })
;

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_unref(sortingStore).sort.length > 1)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(DropdownButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value)),
          label: _unref(sortingStore).getSelectedSortLabelById,
          "is-open": isOpen.value
        }, null, 8, ["label", "is-open"]),
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 0,
              class: _normalizeClass(["q-dropdown-menu sorting-dropdown__list q-shadow-sm q-rounded-3", computedClass.value]),
              "aria-labelledby": "sortingDropdown"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortingStore).sort, (sort) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: sort.id
                }, [
                  _createElementVNode("a", {
                    class: "q-dropdown-item sorting-dropdown__item",
                    onClick: ($event: any) => (updateSorting(sort))
                  }, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(sort.label), 1)
                  ], 8, _hoisted_2)
                ]))
              }), 128))
            ], 2))
          : _createCommentVNode("", true)
      ])), [
        [_directive_click_outside, closeDropdown]
      ])
    : _createCommentVNode("", true)
}
}

})